import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./output.css";
import "./empreenderUI/styles/empreender.css";
// Visual da central (tela inicial e conversa), por último para valer sobre os anteriores.
import "./visual.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PerguntaProvider } from "./contexts/PerguntaContext";
import { HistoricoProvider } from "./contexts/HistoricoContext";
import i18n from "./i18n";
import { HelmetProvider } from "react-helmet-async";
import { prepararIdioma } from "./lib/idioma";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Descobre o idioma pelo país do IP antes do primeiro render (no máximo ~1,2 s, e só na
// primeira visita da semana), para a pessoa já cair no idioma certo sem trocar à mão.
prepararIdioma().then((idioma) => {
  if (i18n.language !== idioma) i18n.changeLanguage(idioma);

  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <PerguntaProvider>
          <HistoricoProvider>
            <App />
          </HistoricoProvider>
        </PerguntaProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
